import { render, staticRenderFns } from "./PercentageGainInput.vue?vue&type=template&id=bebcad8a&"
import script from "./PercentageGainInput.vue?vue&type=script&lang=js&"
export * from "./PercentageGainInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports